import { render, staticRenderFns } from "./MinhasNotas.vue?vue&type=template&id=1c46f6a7&"
import script from "./MinhasNotas.vue?vue&type=script&lang=js&"
export * from "./MinhasNotas.vue?vue&type=script&lang=js&"
import style0 from "./MinhasNotas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports